import { ReactElement } from "react";

export const PlantIcon = (color?: string): ReactElement => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_373_194689)">
        <path
          d="M12 2.66667H4C2.89543 2.66667 2 3.5621 2 4.66667V11.3333C2 12.4379 2.89543 13.3333 4 13.3333H12C13.1046 13.3333 14 12.4379 14 11.3333V4.66667C14 3.5621 13.1046 2.66667 12 2.66667Z"
          stroke={color ?? '#303E47'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.00001 8C6.73638 8 7.33334 7.40305 7.33334 6.66667C7.33334 5.93029 6.73638 5.33333 6.00001 5.33333C5.26363 5.33333 4.66667 5.93029 4.66667 6.66667C4.66667 7.40305 5.26363 8 6.00001 8Z"
          stroke={color ?? '#303E47'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 5.33333H11.3333"
          stroke={color ?? '#303E47'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 8H11.3333"
          stroke={color ?? '#303E47'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.66667 10.6667H11.3333"
          stroke={color ?? '#303E47'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_373_194689">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
